import { useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LogOut, ExternalLink, Inbox, FileText, Images, Bell, Settings } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import AdminGuard from "@/components/admin/AdminGuard";
import LeadsPanel from "@/pages/admin/LeadsPanel";
import BlogPanel from "@/pages/admin/BlogPanel";
import MediaPanel from "@/pages/admin/MediaPanel";
import NotificationsPanel from "@/pages/admin/NotificationsPanel";
import SettingsPanel from "@/pages/admin/SettingsPanel";
import { clearToken } from "@/lib/adminApi";

const TABS = ["leads", "blog", "media", "notifications", "settings"];
const triggerCls = "data-[state=active]:bg-[#C8A24A] data-[state=active]:text-[#141517] text-[#EDE7DA]";

function Dashboard() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = TABS.includes(params.get("tab")) ? params.get("tab") : "leads";

  const logout = () => {
    clearToken();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0E0F10] text-[#EDE7DA]">
      <Helmet><title>Yönetim Paneli</title><meta name="robots" content="noindex,nofollow" /></Helmet>
      <header className="border-b border-white/10 bg-[#0B0C0D]">
        <div className="container-lux flex items-center justify-between h-16">
          <div className="font-display text-base sm:text-xl text-[#F7F2E8] whitespace-nowrap">Ankara <span className="text-[#C8A24A]">Düğün</span> Fotoğrafı<span className="hidden sm:inline"> · Yönetim</span></div>
          <div className="flex items-center gap-2">
            <a href="/" target="_blank" rel="noreferrer">
              <Button variant="outline" size="sm" className="border-white/15 text-[#EDE7DA] bg-transparent hover:bg-white/5">
                <ExternalLink className="w-4 h-4 mr-2" /> Siteyi Gör
              </Button>
            </a>
            <Button variant="outline" size="sm" onClick={logout} data-testid="admin-logout-button"
              className="border-white/15 text-[#EDE7DA] bg-transparent hover:bg-white/5">
              <LogOut className="w-4 h-4 mr-2" /> Çıkış
            </Button>
          </div>
        </div>
      </header>

      <main className="container-lux py-8">
        <h1 className="font-display text-3xl text-[#F7F2E8] mb-6">Kontrol Paneli</h1>
        <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
          <TabsList className="bg-[#141517] border border-white/10 h-auto flex-wrap justify-start">
            <TabsTrigger value="leads" data-testid="tab-leads" className={triggerCls}>
              <Inbox className="w-4 h-4 mr-2" /> Teklif Talepleri
            </TabsTrigger>
            <TabsTrigger value="blog" data-testid="tab-blog" className={triggerCls}>
              <FileText className="w-4 h-4 mr-2" /> Blog Yönetimi
            </TabsTrigger>
            <TabsTrigger value="media" data-testid="tab-media" className={triggerCls}>
              <Images className="w-4 h-4 mr-2" /> Görseller
            </TabsTrigger>
            <TabsTrigger value="notifications" data-testid="tab-notifications" className={triggerCls}>
              <Bell className="w-4 h-4 mr-2" /> Bildirimler
            </TabsTrigger>
            <TabsTrigger value="settings" data-testid="tab-settings" className={triggerCls}>
              <Settings className="w-4 h-4 mr-2" /> Ayarlar
            </TabsTrigger>
          </TabsList>
          <TabsContent value="leads" className="mt-6"><LeadsPanel /></TabsContent>
          <TabsContent value="blog" className="mt-6"><BlogPanel /></TabsContent>
          <TabsContent value="media" className="mt-6"><MediaPanel /></TabsContent>
          <TabsContent value="notifications" className="mt-6"><NotificationsPanel /></TabsContent>
          <TabsContent value="settings" className="mt-6"><SettingsPanel /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}

export default function AdminDashboard() {
  return (
    <AdminGuard>
      <Dashboard />
    </AdminGuard>
  );
}
